import React from 'react'
import Header from '../Comman/Header'
import Footer from '../Comman/Footer'
import RegisterMain from './RegisterMain'

export default function Register() {
    return (
        <>
            <Header />
            <RegisterMain />
            <Footer />
        </>
    )
}
